module.exports = require("./km-KH.js");